import React from 'react';

import { APPLE_LOGO_PATH, GOOGLE_LOGO_PATHS } from '../../../util/brandLogoPaths';

// This is Facebook's logo, you are not allowed to change its color
export const FacebookLogo = ({ ariaLabelledBy }) => (
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={ariaLabelledBy}
  >
    <path
      d="M7.89.214C4.055 1.047 1.005 4.13.205 7.947c-.734 3.45.533 7.283 3.166 9.6.967.85 3.2 2.033 4.15 2.183l.617.1v-6.883H5.806v-3h2.283l.083-1.633c.134-2.417.717-3.534 2.3-4.25.617-.284 1.034-.35 2.3-.334.85.017 1.617.084 1.7.134.1.05.167.7.167 1.433v1.317h-.983c-1.484 0-1.75.283-1.817 1.983l-.067 1.35h1.45c1.284 0 1.434.033 1.35.283-.05.167-.133.667-.2 1.134-.216 1.55-.25 1.583-1.483 1.583h-1.083V19.914l.866-.234c1.684-.433 2.984-1.216 4.4-2.633 2.067-2.067 2.9-4.1 2.9-7.017 0-3.166-1.2-5.75-3.616-7.766C14.106.38 10.772-.42 7.889.214z"
      fill="#1877F2"
      fillRule="nonzero"
    />
  </svg>
);

// This is Apple's logo, you are not allowed to change its color.
//
// Framing per Apple's HIG, "Sign in with Apple › Creating a custom Sign in with Apple button"
// (developer.apple.com/design/human-interface-guidelines/sign-in-with-apple). Measured off the
// button Apple itself renders (appleid.cdn-apple.com/appleid/button at 375x64): the glyph is
// 17x20px inside a 64px-tall button — 31.25% of the button height — and centred.
//
// The outline below is unchanged; what was wrong was the box around it. The path draws into
// x 7.45..17.36, y 2.40..14.37, so in the old `0 0 20 20` viewBox the glyph carried 7.45 units of
// padding on the left against 2.63 on the right and rendered at 24.9% of the button height. It
// came out visibly small and shoved to the right next to Google's logo, which fills its box.
// The viewBox is now tight to the glyph, which makes `height` the glyph height directly — that is
// what lets the CSS honour Apple's "match the height of the logo file to the height of the button"
// rule (15px = 31.25% of the 48px button both surfaces use). Do not add vertical padding here:
// per the HIG, the button centres the logo, the logo file does not pad itself.
export const AppleLogo = ({ ariaLabelledBy }) => (
  <svg
    width="12.4"
    height="15"
    viewBox="7.45 2.4 9.91 11.97"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={ariaLabelledBy}
  >
    <path d={APPLE_LOGO_PATH} fill="#000000" fillRule="nonzero" />
  </svg>
);

// This is Google's logo, you are not allowed to change its color
export const GoogleLogo = ({ ariaLabelledBy }) => (
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={ariaLabelledBy}
  >
    <g fill="none" fillRule="evenodd">
      {GOOGLE_LOGO_PATHS.map(({ d, fill }) => (
        <path key={fill} d={d} fill={fill} />
      ))}
      <path d="M0 0h20v20H0z" />
    </g>
  </svg>
);
